import {Component, Injector, input} from '@angular/core';
import {NgbOffcanvas} from "@ng-bootstrap/ng-bootstrap/offcanvas";
import {SidebarComponent} from "../home-page/sidebar/sidebar.component";
import {faBars} from "@fortawesome/free-solid-svg-icons/faBars";
import {faBook} from "@fortawesome/free-solid-svg-icons/faBook";
import {faMapLocationDot} from "@fortawesome/free-solid-svg-icons/faMapLocationDot";
import {faPhone} from "@fortawesome/free-solid-svg-icons/faPhone";
import {faFacebookSquare} from "@fortawesome/free-brands-svg-icons/faFacebookSquare";
import {faInstagram} from "@fortawesome/free-brands-svg-icons/faInstagram";
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {NgOptimizedImage} from '@angular/common';
import {Constants} from "../constants";
import {TrackingService} from "../tracking/tracking.service";
import {scheduleInitiated} from "../tracking/tracking-event";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  imports: [FaIconComponent, NgOptimizedImage]
})
export class NavbarComponent {

  readonly complex = input.required<boolean>();
  readonly withServices = input<boolean>(false);
  readonly withBlog = input<boolean>(false);

  protected readonly faBook = faBook;
  protected readonly faPhone = faPhone;
  protected readonly faMapLocationDot = faMapLocationDot;
  protected readonly faInstagram = faInstagram;
  protected readonly faFacebookSquare = faFacebookSquare;
  protected readonly faBars = faBars;

  protected readonly routes = Constants.Routes;
  protected readonly company = Constants.Company;
  protected readonly contact = Constants.Contact;
  protected readonly address = Constants.Address;
  protected readonly social = Constants.Social;

  constructor(private readonly offCanvasService: NgbOffcanvas,
              private readonly trackingService: TrackingService,
              private readonly injector: Injector) {
  }

  openSidebar() {
    this.offCanvasService.open(SidebarComponent, {
      panelClass: 'sidebar'
    })
      .componentInstance
      .servicesVisible(this.withServices())
      .blogVisible(this.withBlog());
  }

  async openBooksyDialog() {
    this.trackingService.track(scheduleInitiated());
    const {NgbModal} = await import("@ng-bootstrap/ng-bootstrap/modal");
    const {BooksyDialogComponent} = await import("../home-page/booksy-dialog/booksy-dialog.component");
    this.injector.get(NgbModal).open(BooksyDialogComponent, {
      keyboard: false,
      beforeDismiss: () => false
    });
  }

}
